import BaseRepository from '@/baseRepository/BaseRepository';
import qs from 'qs';
const resource = `/api/v1/categories`;
const merchantCategoriesResource = `/api/v1/merchantcategories`;

export default {
  getCategoriesListBySelection(baseURL = {}, params = {}, headers = {}) {
    return BaseRepository.get(`${resource}`, {
      baseURL,
      headers,
      params,
      paramsSerializer: (params) => {
        return qs.stringify(params, { arrayFormat: 'repeat' });
      },
    });
  },
  getCategoriesTreeListMoreData(baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(`${resource}/more-data`, {
      baseURL,
      headers,
      params,
      paramsSerializer: (params) => {
        return qs.stringify(params, { arrayFormat: 'repeat' });
      },
    });
  },
  getCategoriesList(baseURL = {}, params = {}, headers = {}) {
    return BaseRepository.get(`${resource}`, {
      baseURL,
      headers,
      params,
      paramsSerializer: (params) => {
        return qs.stringify(params, {
          arrayFormat: 'repeat',
        });
      },
    });
  },
  getCategoriesListMenu(baseURL = {}, params = {}, headers = {}) {
    return BaseRepository.get(`${resource}/menu`, {
      baseURL,
      headers,
      params,
      paramsSerializer: (params) => {
        return qs.stringify(params, {
          arrayFormat: 'repeat',
        });
      },
    });
  },
  getCategoryById(id, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(`${resource}/${id}`, {
      baseURL,
      headers,
      params,
    });
  },
  getCategoryTree(baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(`${resource}`, {
      baseURL,
      headers,
      params,
    });
  },
  getCategoryByIdList(
    baseURL = {},
    headers = {},
    params = {},
    paramsSerializer
  ) {
    return BaseRepository.get(`${resource}/by-id-list`, {
      baseURL,
      headers,
      params,
      paramsSerializer,
    });
  },
  getCategoryProductPropertiesById(
    id,
    baseURL = {},
    headers = {},
    params = {}
  ) {
    return BaseRepository.get(`${resource}/${id}/products/properties`, {
      baseURL,
      headers,
      params,
    });
  },
  editCategoryById(body, id, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.put(`${resource}/${id}`, body, {
      baseURL,
      headers,
      params,
    });
  },
  addCategory(body, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.post(`${resource}`, body, {
      baseURL,
      headers,
      params,
    });
  },
  deleteCategoryById(id, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.delete(`${resource}/${id}`, {
      baseURL,
      headers,
      params,
    });
  },

  getMerchantCategoriesByIds(baseURL = {}, params = {}, headers = {}) {
    return BaseRepository.get(
      `${merchantCategoriesResource}/breadcrumb/by-id-list`,
      {
        baseURL,
        params,
        headers,
      }
    );
  },
  getMerchantCategoriesBreadCrumb(baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(`${merchantCategoriesResource}/breadcrumb`, {
      baseURL,
      params,
      headers,
    });
  },
  addCategoryBySupplier(body, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.post(
      `${merchantCategoriesResource}/bysupplier`,
      body,
      {
        baseURL,
        headers,
        params,
      }
    );
  },
  getMerchantCategoryByCategoryId(baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(`${merchantCategoriesResource}/by-category-id`, {
      baseURL,
      headers,
      params,
    });
  },
  deleteMerchantCategoryById(id, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.delete(
      `${merchantCategoriesResource}/${id}/by-supplier`,
      {
        baseURL,
        headers,
        params,
      }
    );
  },
};
